import { LitElement, html } from "lit";
import { customElement } from "lit/decorators.js";

import AtlasSection from "@/components/layout/atlas-section/atlas-section";
import styles from "./atlas-section-group.scss";

/**
 * Grupo de seções, para quando é necessitado o comportamento de, ao abrir uma seção, fechar as demais
 *
 * @tag atlas-section-group
 */
@customElement("atlas-section-group")
export default class AtlasSectionGroup extends LitElement {
    static styles = styles;

    connectedCallback() {
        super.connectedCallback?.();

        this.addEventListener("atlas-section-expand", this.onSectionExpand);
    }

    disconnectedCallback() {
        super.disconnectedCallback?.();

        this.removeEventListener("atlas-section-expand", this.onSectionExpand);
    }

    getSlottedSections() {
        return this.shadowRoot.querySelector("slot").assignedElements() || [];
    }

    onSectionExpand(event: CustomEvent) {
        this.getSlottedSections().forEach((section: AtlasSection) => {
            if (event.target !== section && section.collapsed !== true) {
                section.close();
            }
        });
    }

    render() {
        return html`
            <div class="section-group">
                <slot></slot>
            </div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "atlas-section-group": AtlasSectionGroup;
    }
}
